import React from 'react';

export function Container({children, format}) {

    return (
        <div className={(format != null ? format.classes : "")}>{children}</div>
    );

}